import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const STATS = [
  { key: "totalUser", label: "Total users", icon: "mdi:account-group-outline", tone: "" },
  { key: "paidUser", label: "Paid users", icon: "mdi:crown-outline", tone: "tone-info" },
  { key: "freeUser", label: "Free users", icon: "mdi:account-outline", tone: "tone-warn" },
  { key: "instances", label: "Instances", icon: "mdi:whatsapp", tone: "" },
  { key: "pendingPings", label: "Open support issues", icon: "mdi:message-badge-outline", tone: "tone-danger" },
  { key: "totalOrders", label: "Total orders", icon: "mdi:cart-outline", tone: "tone-info" },
  { key: "dailyDataOrders", label: "Orders (24h)", icon: "mdi:clock-outline", tone: "" },
  { key: "totalSent", label: "Messages sent", icon: "mdi:send-outline", tone: "" },
  { key: "totalActiveBots", label: "Active bots", icon: "mdi:robot-outline", tone: "tone-info" },
  { key: "scrap_entries", label: "Scrap entries", icon: "mdi:database-outline", tone: "tone-warn" },
  { key: "dailyDataLogs", label: "Logs (24h)", icon: "mdi:clipboard-text-clock-outline", tone: "" },
  { key: "monthBasedOrder", label: "Orders (month)", icon: "mdi:calendar-month-outline", tone: "tone-info" },
];

const QUICK = [
  { to: "/admin/users", label: "Manage users", icon: "mdi:account-cog-outline" },
  { to: "/admin/plans", label: "Plans & pricing", icon: "mdi:package-variant-closed" },
  { to: "/admin/pings", label: "Support chat", icon: "mdi:message-reply-text-outline" },
  { to: "/admin/orders", label: "Orders", icon: "mdi:receipt-text-outline" },
];

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Admin Dashboard";
    (async () => {
      try {
        const data = await adminApi({ url: "admin/get-dashboard", method: "GET" });
        if (handleAdminLogoutIfNeeded(data)) return;
        if (!data.success) {
          setError(data.msg || "Failed to load dashboard");
          return;
        }
        setStats(data);
      } catch {
        setError("Failed to load dashboard");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="Admin dashboard"
          subtitle="Platform overview — users, messaging, and revenue signals."
          action={
            <Link className="admin-btn admin-btn-primary" to="/admin/users">
              <Icon icon="mdi:account-plus-outline" width={18} />
              Manage users
            </Link>
          }
        />

        {error ? <div className="admin-alert admin-alert-danger">{error}</div> : null}

        <div className="admin-stat-grid">
          {STATS.map((s) => (
            <div key={s.key} className={`admin-stat-card ${s.tone}`}>
              <div className="admin-stat-icon">
                <Icon icon={s.icon} width={22} />
              </div>
              <p className="admin-stat-label">{s.label}</p>
              <p className="admin-stat-value">
                {loading ? "—" : (stats?.[s.key] ?? 0).toLocaleString?.() ?? stats?.[s.key] ?? 0}
              </p>
            </div>
          ))}
        </div>

        <p className="admin-section-title">Quick actions</p>
        <div className="admin-plan-grid" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))" }}>
          {QUICK.map((q) => (
            <Link key={q.to} to={q.to} className="admin-plan-card" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="admin-stat-icon" style={{ width: 40, height: 40 }}>
                <Icon icon={q.icon} width={22} />
              </div>
              <h3 className="admin-plan-name" style={{ fontSize: "1rem" }}>{q.label}</h3>
              <p style={{ margin: 0, color: "#667781", fontSize: "0.85rem" }}>Open module →</p>
            </Link>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
